module.exports = __webpack_public_path__ + "img/rank_award_info.0f220374.png";